import React, { useState, createContext, useEffect } from 'react'


export const VenueContext = createContext();

export function VenueProvider(props) {

    const [venues, setVenues] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [tempData, setTempData] = useState(venues);
    const [dma, setDma] = useState(0)
    const TICKET_ID = process.env.REACT_APP_TICKET_ID
    const getVenues = async () => {
        const response = await fetch(`https://app.ticketmaster.com/discovery/v2/venues.json?apikey=${TICKET_ID}&stateCode=CA&size=200`);
        const data = await response.json();
        setVenues(data._embedded.venues)
        setTempData(data._embedded.venues)
        setIsLoading(false);
    }
    useEffect(() => {
        getVenues();
        window.scrollTo(0, 0);
    }, [])
    
    function getSpecificVenues(code) {
        setDma(code);
        console.log(dma);
       let specificVenues = tempData.filter(venue => {
           setIsLoading(true);
            var elem;
            for (elem of venue.dmas) {
                if (elem.id === code) {
                    return elem
                }
            }
        })
        setIsLoading(false);
    return setVenues(specificVenues)
  
    }


    function getVenueDetails(slug) {
        return venues.find(venue => {
            return venue.name == slug;
        })
    }
    return (
        <VenueContext.Provider value={{
            dma: dma,
            setDma:setDma,
            venues:venues,
            isLoading:isLoading,
            getVenueDetails: getVenueDetails,
            getVenues: getVenues,
            getSpecificVenues: getSpecificVenues,
            setVenues:setVenues
        
        }}>
        {props.children}
        </VenueContext.Provider>
    )
}
